import Vue from 'vue';
import { n as normalizeComponent } from './normalize-component-cf2db48b.js';
import { c as createInjector } from './browser-ac904bdc.js';

var script = Vue.extend({
  name: "tmd-badge",
  props: {
    value: {
      type: Number,
      required: false
    },
    values: {
      type: Array,
      required: false
    },
    maxValue: {
      type: Number,
      default: 99
    },
    small: {
      type: Boolean,
      default: false
    },
    position: {
      type: Object,
      default: () => ({
        top: "-4px",
        left: "90%"
      })
    }
  },
  computed: {
    displayValues() {
      if (this.values === undefined) {
        return [{
          value: this.value,
          theme: "#ef5350"
        }];
      } else if (this.values.length !== 0) {
        return this.values;
      } else {
        return [];
      }
    },
    styles() {
      if (this.values === undefined) {
        return [{
          ...this.position,
          backgroundColor: "#ef5350"
        }];
      } else {
        return this.values.map((value, index) => {
          return {
            top: `${-4 + index * 14}px`,
            left: "90%",
            backgroundColor: `${value.theme}`
          };
        });
      }
    }
  },
  methods: {
    parseValue(value) {
      if (value <= 0) {
        return "";
      } else if (this.maxValue > 0 && value > this.maxValue) {
        return `${this.maxValue}+`;
      } else {
        return `${value}`;
      }
    }
  }
});

const __vue_script__ = script;
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "tmd-badge"
  }, [_vm._t("default"), _vm._v(" "), _vm._l(_vm.displayValues, function (badge, index) {
    return _c('span', {
      key: index,
      class: ['tmd-badge__counter', 'tmd-caption', {
        'tmd-badge__counter--small': _vm.small,
        'tmd-badge__empty': badge.value <= 0
      }],
      style: _vm.styles[index] || _vm.position
    }, [_vm._v("\n    " + _vm._s(_vm.parseValue(badge.value)) + "\n  ")]);
  })], 2);
};
var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-676d24b4_0", {
    source: ".tmd-badge[data-v-676d24b4]{position:relative;display:inline-block}.tmd-badge__empty[data-v-676d24b4]{background-color:transparent!important}.tmd-badge .tmd-badge__counter[data-v-676d24b4]{position:absolute;z-index:3;display:flex;overflow:hidden;min-width:16px;width:auto;height:16px;padding:4px;border-radius:8px;align-items:center;justify-content:center;pointer-events:none;transition:.3s cubic-bezier(.4,0,.2,1)}.tmd-badge .tmd-badge__counter--small[data-v-676d24b4]{font-size:10px;min-width:14px;height:14px}",
    map: undefined,
    media: undefined
  });
};
const __vue_scope_id__ = "data-v-676d24b4";
const __vue_module_identifier__ = undefined;
const __vue_is_functional_template__ = false;
const __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

export { __vue_component__ as default };
